import { render, staticRenderFns } from "./LinksIegm.vue?vue&type=template&id=bab3bb14"
import script from "./LinksIegm.vue?vue&type=script&lang=ts"
export * from "./LinksIegm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports